import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Table, Spin } from "antd";
import Breadcrumbs from "../../../components/Breadcrumbs";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import { getAllLeaves } from "../../../services/leaveService";
import { formatDateInTimezone } from "../../../utils/formatDateInTimezone";
import { getLabelByValue } from "../../../utils/getLabelByValue";
import { getAllExpenses } from "../../../services/reimbursementService";
import config from "../../../config";
import { companyID, DepartmentID } from "../../../auth";
import RowDetailModal from "../../../components/RowDetailModal";
import { useMediaQuery } from "react-responsive";
import { formatDecimal } from "../../../utils/formatDecimal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";
import { convertAttendanceTotalHours } from "../../../utils/convertAttendanceTotalHours";
import api from "../../../api/axios";
import AttachmentModal from "../../../components/modelpopup/AttachmentModal";
import Loader from "../../../components/Loader";
import Swal from "sweetalert2";
import { capitalizeFirstLetter } from "../../../utils/basicFunctions";
import FilterComponent from "../../../components/FilterComponent";
import CreateTask from "./CreateTask";
import { useTranslation } from "react-i18next";
import {
  approveEmployeeAbsence,
  rejectEmployeeAbsence,
} from "../../../services/taskboxServices";
import { decrypt } from "../../../utils/crypto";

const Taskbox = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let { employee_id } = useParams();
  employee_id = decrypt(employee_id);
  const location = useLocation();
  const { employeeName = "" } = location.state || {};
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [paginationValue, setPaginationValue] = useState(10);
  const [leaves, setLeaves] = useState([]);
  const [leaveElements, setLeaveElements] = useState([]); // New state for leaveElements
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [expenses, setExpenses] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(0);
  const [reimbursementId, setReimbursementId] = useState(null);
  const [acknowledge, setAcknowledge] = useState(false);
  const [acknowledgeAttachment, setAcknowledgeAttachment] = useState(null);
  const [updatedRemainingDays, setUpdatedRemainingDays] = useState({});
  const [spinner, setSpinner] = useState({
    show: false,
    message: "",
  });
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [taskType, setTaskType] = useState("workplace");
  const loginEmployeeId = localStorage.getItem("employeeID");
  const department_id = DepartmentID();
  const role_id = localStorage.getItem("employee_role");
  const [assignmentTaskFilter, setAssignmentTaskFilter] = useState(null);
  const [rejectionReasonError, setRejectionReasonError] = useState({});
  const [rejectionReason, setRejectionReason] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleAbsenteeAction = async (record, action) => {
    if (action.label === "Reject") {
      if (!rejectionReason) {
        setRejectionReasonError((prev) => ({
          ...prev,
          [record.key]: "Please give a valid rejection reason.",
        }));
        return;
      } else if (rejectionReason.length < 10) {
        setRejectionReasonError((prev) => ({
          ...prev,
          [record.key]: "Please explain the reason in detail.",
        }));
        return;
      }
      setSpinner({ show: true, message: `Rejecting absentee task` });
      try {
        const result = await rejectEmployeeAbsence(
          loginEmployeeId,
          record.task_id,
          rejectionReason
        );
        if (result?.success !== true) {
          throw new Error(
            result?.data?.message || "Failed to reject absentee task"
          );
        }
        setRejectionReason("");
        setRejectionReasonError({});
        closeModal();
        Swal.fire({
          title: "Absentee Task",
          text: `Absentee task rejected successfully`,
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        await fetchLeaves();
      } catch (error) {
        Swal.fire({
          title: "Warning",
          text: "Failed to reject absentee task. Please try again.",
          icon: "warning",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        });
      } finally {
        setSpinner({ show: false, message: "" });
      }
    } else {
      setSpinner({ show: true, message: `Approving absentee task` });
      try {
        const result = await approveEmployeeAbsence(
          loginEmployeeId,
          record.task_id,
          {
            allow_leave:
              action.label === "Allow Leave" ? "APPROVED" : "REJECTED",
            allow_attendance_approval:
              action.label === "Allow Attendance" ? "APPROVED" : "REJECTED",
          }
        );

        if (result?.success != true) {
          throw new Error(
            result?.data?.message || "Failed to perform absentee action"
          );
        }
        setRejectionReason("");
        setRejectionReasonError({});
        closeModal();
        Swal.fire({
          title: "Absentee Task",
          text: `${action.label} successfully`,
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        await fetchLeaves();
      } catch (error) {
        Swal.fire({
          title: "Warning",
          text: "Failed to reject absentee task. Please try again.",
          icon: "warning",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        });
      } finally {
        setSpinner({ show: false, message: "" });
      }
    }
  };

  console.log("selectedRow" , selectedRow);

  const filterOptions =
    taskType === "workplace"
      ? [
          {
            key: "Approved",
            label: "status",
            value: [2, "approved", "APPROVED"],
            category: "Status",
          },
          {
            key: "Pending",
            label: "status",
            value: [1, "pending", "PENDING"],
            category: "Status",
          },
          {
            key: "Rejected",
            label: "status",
            value: [3, "rejected", "REJECTED"],
            category: "Status",
          },
          {
            key: "All",
            label: "status",
            value: null,
            category: "Status",
          },
        ]
      : [
          {
            key: "Completed",
            label: "task_status",
            value: ["completed"],
            category: "Task Status",
          },
          {
            key: "In progress",
            label: "task_status",
            value: ["in_progress"],
            category: "Task Status",
          },
          {
            key: "To do",
            label: "task_status",
            value: ["to_do"],
            category: "Task Status",
          },
        ];

  const fetchLeaves = async () => {
    try {
      const response = await api.get(
        `api/reimbursement-for-approval/${employee_id}`
      );

      const response2 = await api.get(
        `employeseApproval/${employee_id}?department_id=${
          role_id !== "2" ? "" : department_id
        }`
      );
      const response3 = await api.get(`leave-for-approval/${employee_id}`);
      const response4 = await api.get(
        `api/reimbursementsForApproval/${employee_id}`
      );
      const response5 = await api.get(
        `api/attendance/getAllAttendanceApprovals/${employee_id}`
      );
      const response6 = await api.get(
        `employee-absences/reportees/${employee_id}`
      );
      const wfdDate = await api.get(
              `company/work_date?approver_id=${employee_id}`
            );
      let combinedData = [];
      if(wfdDate?.data?.data?.length > 0){
          combinedData= [...combinedData , ...wfdDate?.data?.data ];
      }

      if (response?.data?.result?.length > 0) {
        combinedData = [...combinedData, ...response?.data?.result];
      }
      if (
        response2?.data?.result?.length > 0 &&
        loginEmployeeId === employee_id
      ) {
        combinedData = [...combinedData, ...response2?.data?.result];
      }
      if (response3?.data?.result?.length > 0) {
        combinedData = [...combinedData, ...response3?.data?.result];
      }
      if (response4?.data?.result?.length > 0) {
        combinedData = [...combinedData, ...response4?.data?.result];
      }
      if (response5?.data?.data?.length > 0) {
        combinedData = [
          ...combinedData,
          ...response5?.data?.data?.map((attendance) => ({
            ...attendance,
            taskType: "ATTENDANCE",
          })),
        ];
      }
      if (response6?.data?.absence?.length > 0) {
        combinedData = [
          ...combinedData,
          ...response6?.data?.absence?.map((absence) => ({
            ...absence,
            taskType: "Absentee",
          })),
        ];
      }

      setLeaves(combinedData);

      console.log("combinedData", combinedData)

      // Transform and set leaveElements
      const transformedData = combinedData
        .map((data, index) => ({
          key: index + 1,
          name: data?.first_name + " " + data?.last_name || "",
          type: data?.work_date ? "WORK_FROM_HOME" :
            getLabelByValue(leavetype, data.leave_type) ||
            data.expense_type ||
            data.taskType ,
          leave_type_id: data?.leave_type,
          leave_days: data?.leave_days,
          appliedOn: formatDateInTimezone(data.created_at),
          appliedfor: data.start_date
            ? `${formatDateInTimezone(data.start_date)} to ${formatDateInTimezone(
                data.end_date
              )}`
            :  data?.work_date ? formatDateInTimezone(data?.work_date)  : `${formatDateInTimezone(
                data.expense_date ??
                  data.attendance_for_approval ??
                  data.absent_date
              )}` ,
          status:
            data?.updated_status ?? data?.expense_status ?? data?.approval_status ?? data?.approved_status,
          task_type:  data.expense_type
            ? "REIMBURSEMENT"
            : getLabelByValue(leavetype, data.leave_type)
            ? "LEAVE"
            : data?.work_date ? "WORK_FROM_HOME" : data?.taskType,
          employee_id: data.employee_id,
          task_id: data.id || data.attendance_id,
          updated_status: data?.updated_status ?? data?.approval_status ?? 1,
          attachment: data?.attachment,
          applicant_id: data?.applicant_id,
          approval_id: data?.approval_id,
          message: data.message ?? null,
          reason:
            getLabelByValue(leaveReason, data.leave_reason) ??
            data.expense_type ??
            getLabelByValue(reasonType, data.reason) ??
            null,
          leave_days: formatDecimal(data.leave_days) ?? null,
          leave_apply_period:
            getLabelByValue(leavePeriod, data.leave_apply_period) ?? null,
          punchIn: data.punchIn ? moment(data.punchIn).format("hh:mm:ss A") : null,
          punchOut: data.punchOut
            ? moment(data.punchOut).format("hh:mm:ss A")
            : null,
          totalHours: data.totalHours
            ? convertAttendanceTotalHours(data.totalHours)
            : null,
          amount: data?.expense_amount ?? null,
          rejection_reason: data?.rejection_reason ?? null,
          rejection_reason_input:
            data?.taskType === "Absentee" ? data?.taskType : null,
          approver_action_taken: data?.approver_action_taken ?? null,
          remark: data?.remark ?? "", 
          wfh_id : data?.wfh_id ,
          wfh_approved_status : data?.approved_status != "pending" ? 1 : 0,
          wfh_status : data?.approved_status
        }))
        .sort((a, b) => new Date(b.appliedOn) - new Date(a.appliedOn));

      setLeaveElements(transformedData);
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaves();
  }, []);

  const company_id = companyID();

  const leavetype = [
    { value: "", label: "Select leave type" },
    { value: 1, label: "Sick Leave" },
    { value: 2, label: "Casual Leave" },
    { value: 3, label: "Vacation" },
    { value: 4, label: "Unpaid Leave" },
    { value: 5, label: "Compensatory Off Leave" },
  ];

  const leavePeriod = [
    { value: 1, label: "Full day" },
    { value: 2, label: "First half" },
    { value: 3, label: "Second half" },
  ];

  const reasonType = [
    { value: 1, label: "Not in location issue" },
    { value: 2, label: "App not loading properly" },
    { value: 3, label: "Forgot to login in app" },
    { value: 4, label: "Forgot to logout from app" },
    { value: 5, label: "New Joinee Registration Process Not Completed" },
    { value: 6, label: "Weather-related delay" },
    { value: 7, label: "Public transport delays." },
    { value: 8, label: "Traffic congestion or road closure." },
    { value: 9, label: "Unexpected personal emergencies" },
    { value: 10, label: "Network outage." },
    { value: 11, label: "Other." },
  ];

  const leaveReason = [
    { value: 1, label: "Illness" },
    { value: 2, label: "Family Emergency" },
    { value: 3, label: "Childcare" },
    { value: 4, label: "Vacation Travel" },
    { value: 5, label: "Personal Reasons" },
    { value: 6, label: "Medical Appointment" },
  ];

  const filteredLeaveElements = leaveElements.filter((element) => {
    if (
      !selectedFilter ||
      Object.values(selectedFilter).every((value) => value === null)
    ) {
      return (
        Number(element.status) === 1 ||
        element.status === "pending" ||
        element.status === "PENDING"
      );
    }
    return Object.entries(selectedFilter).every(([key, value]) => {
      if (
        value === null ||
        (Array.isArray(value) && value.every((v) => v === null))
      ) {
        return true;
      }
      if (Array.isArray(value)) {
        return (
          value.includes(Number(element[key])) || value.includes(element[key])
        );
      }
      return element[key] === value || Number(element[key]) === value;
    });
  });

  const actionStatus = [
    { value: 2, label: "Approve" },
    { value: 3, label: "Reject" },
  ];

  const absenceActionStatus = [
    { value: "APPROVED", label: "Allow Leave" },
    { value: "APPROVED", label: "Allow Attendance" },
    { value: "REJECTED", label: "Reject" },
  ];

 const wFHStatus = [
    { value: "approved", label: "Allow WFH" },
    { value: "rejected", label: "Reject" },
  ];

  const actionStatusHandler = async (status_id, task_id, task_type) => {
    console.log("updatedRemainingDays" , updatedRemainingDays , selectedRow);
    closeModal();
    setSpinner({ show: true, message: `APPROVING ${task_type}` });
    if (task_type == "LEAVE") {
      try {
        setLoading(true);
        const response = await api.post(`leave/${task_id}/approve/`, {
          company_id: company_id,
          approver_id: employee_id,
          status_id: status_id,
          leave_employee_id: selectedRow?.employee_id || updatedRemainingDays?.leave_employee_id,
          no_of_days:  selectedRow?.leave_days ||  updatedRemainingDays?.no_of_days,
          leave_type_id: selectedRow?.leave_type_id || 
 updatedRemainingDays?.leave_type_id,
        });
        if (response) {
          fetchLeaves();
          Swal.fire({
            title: `Leave`,
            text: `Leave ${
              status_id == 2 ? "approved" : "rejected"
            } successfully`,
            icon: "success",
            confirmButtonText: "OK",
            timer: 2000,
            timerProgressBar: true,
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
        }
      } catch (error) {
        console.error("Error updating leave:", error);
        Swal.fire({
          title: `Leave`,
          text: "Something went wrong, please try again later!",
          icon: "warning",
          confirmButtonText: "OK",
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            confirmButton: "btn btn-warning",
          },
        });
      } finally {
        setLoading(false);
        setSpinner({ show: false, message: "" });
      }
    } else {
      try {
        setLoading(true);
        const response = await api.post(
          `api/reimbursementsForApprova/${task_id}`,
          {
            approver_id: employee_id,
            status_id: status_id,
            company_id: company_id,
          }
        );
        if (response) {
          setCurrentStatus(status_id);
          fetchLeaves();
          Swal.fire({
            title: `Reimbursement`,
            text: `Reimbursement ${
              status_id == 2 ? "approved" : "rejected"
            } successfully`,
            icon: "success",
            confirmButtonText: "OK",
            timer: 2000,
            timerProgressBar: true,
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
        }
      } catch (error) {
        console.error("Error approving reimbursement:", error);
        Swal.fire({
          title: `Reimbursement`,
          text: "Something went wrong, please try again later!",
          icon: "warning",
          confirmButtonText: "OK",
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            confirmButton: "btn btn-warning",
          },
        });
      } finally {
        setLoading(false);
        setIsModalOpen(false);
        setSpinner({ show: false, message: "" });
      }
    }
  };

  const updateApprovalStatus = async (
    approval_id,
    status,
    applicant_id,
    date,
    attendance_id,
    remark
  ) => {
    setSpinner({ show: true, message: `Approving attendance` });
    api
      .put(
        `api/attendance/updateAttendanceApproval/${approval_id}/${applicant_id}`,
        {
          status: status,
          updated_by: employee_id,
          date: date,
          attendance_id: attendance_id,
          remark
        }
      )
      .then((res) => {
        Swal.fire({
          title: `Attendance`,
          text: `Attendance ${status} successfully`,
          icon: "success",
          confirmButtonText: "OK",
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        if (res.data.success == "true") {
        }
      })
      .catch((err) => {
        console.error(err);
        Swal.fire({
          title: `Attendance`,
          text: "Something went wrong, please try again later!",
          icon: "warning",
          confirmButtonText: "OK",
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            confirmButton: "btn btn-warning",
          },
        });
      })
      .finally(() => setSpinner({ show: false, message: `` }));
  };

  const attendaceApproval = async (
    applicant_id,
    date,
    approval_id,
    status,
    attendance_id,
    remark
  ) => {
    setSpinner({ show: true, message: `Approving attendance` });
    setLoading(true);
    closeModal();
    if (status == "Approve") {
      api
        .put(
          `api/attendance/attendace/${applicant_id}/${date}/${company_id}/${employee_id}`
        )
        .then((res) => {
          updateApprovalStatus(
            approval_id,
            "approved",
            applicant_id,
            date,
            attendance_id,
            remark
          );
          fetchLeaves(); // Refresh table after approve
        })
        .catch((err) => {
          console.error(err);
          Swal.fire({
            title: `Attendance`,
            text: "Something went wrong, please try again later!",
            icon: "warning",
            confirmButtonText: "OK",
            timer: 2000,
            timerProgressBar: true,
            customClass: {
              confirmButton: "btn btn-warning",
            },
          });
        })
        .finally(() => {
          setLoading(false);
          setSpinner({ show: false, message: `` });
        });
    } else {
      await updateApprovalStatus(
        approval_id,
        "rejected",
        applicant_id,
        date,
        attendance_id,
        remark
      );
      fetchLeaves(); // Refresh table after reject
      setLoading(false);
    }
  };

  const normalizedStatusOrder = {
    pending: 1,
    approved: 2,
    rejected: 3,
  };

  const normalizeStatus = (status) => {
    if (status == "1" || status == "pending" || status == "PENDING")
      return "pending";
    if (status == "2" || status == "approved" || status == "APPROVED")
      return "approved";
    if (status == "3" || status == "rejected" || status == "REJECTED")
      return "rejected";
    return null;
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <span
          className="table-avatar"
          style={{ cursor: "pointer" }}
          onClick={() => onRowClick(record)}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (text, record) => (
        <span
          className="table-avatar"
          style={{ cursor: "pointer" }}
          onClick={() => onRowClick(record)}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Applied on",
      dataIndex: "appliedOn",
      render: (text, record) => (
        <span
          className="table-avatar"
          style={{ cursor: "pointer" }}
          onClick={() => onRowClick(record)}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Applied for",
      dataIndex: "appliedfor",
      render: (text, record) => (
        <span
          className="table-avatar"
          style={{ cursor: "pointer" }}
          onClick={() => onRowClick(record)}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text, record) => (
        <span
          onClick={() => onRowClick(record)}
          style={{
            color:
              record.updated_status === 1 ||
              record.updated_status === "pending" ||
              record.updated_status === "PENDING"
                ? "rgb(255 223 0)"
                : record.updated_status === 2 ||
                  record.updated_status === "approved" ||
                  record.updated_status === "APPROVED"
                ? "green"
                : "red",
            cursor: "pointer",
          }}
        >
          {record.updated_status === 1 ||
          record.updated_status == "pending" ||
          record.updated_status === "PENDING"
            ? "Pending"
            : record.updated_status === 2 ||
              record.updated_status == "approved" ||
              record.updated_status === "APPROVED"
            ? "Approved"
            : "Rejected"}
        </span>
      ),
      sorter: (a, b) => {
        const aNormalized = normalizeStatus(a.updated_status);
        const bNormalized = normalizeStatus(b.updated_status);

        const aValue =
          aNormalized && normalizedStatusOrder[aNormalized]
            ? normalizedStatusOrder[aNormalized]
            : Number.MAX_SAFE_INTEGER;
        const bValue =
          bNormalized && normalizedStatusOrder[bNormalized]
            ? normalizedStatusOrder[bNormalized]
            : Number.MAX_SAFE_INTEGER;

        return aValue - bValue;
      },
      sortDirections: ["ascend", "descend"],
    },
    ...(loginEmployeeId === employee_id
      ? [
          {
            title: "Action",
            render: (record) => (
              <div className="action-menu">
                {record.task_type === "REIMBURSEMENT" ? (
                  <div
                    className="d-flex gap-2 mt-2"
                    style={{
                      cursor:
                        record.updated_status === 1 ? "pointer" : "not-allowed",
                    }}
                  >                  
                      <button
                        disabled={record.updated_status === 1 ? false : true}
                        className="list-group-item list-group-item-action"
                        onClick={(e) => {
                          e.preventDefault();
                          setIsModalOpen(true);
                          setCurrentStatus(record?.updated_status);
                          setReimbursementId(record?.task_id);
                          setAcknowledgeAttachment(record?.attachment);
                        }}
                      >
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip
                              id="tooltip-view"
                              style={{ fontSize: "12px", padding: "2px" }}
                            >
                              Take Action
                            </Tooltip>
                          }
                        >
                          <i class="fa-solid fa-ellipsis-vertical"/>
                        </OverlayTrigger>
                      </button>
                    
                  </div>
                ) : record.task_type === "LEAVE" ? (
                  <div
                    className="d-flex gap-2 mt-2"
                    style={{
                      cursor:
                        record.updated_status === 1 ? "pointer" : "not-allowed",
                    }}
                  >    
                      <button
                        disabled={record.updated_status === 1 ? false : true}
                        className="list-group-item list-group-item-action"
                        
                        onClick={(e) => {
                          e.preventDefault();
                          onRowClick(record);
                        }}
                      >
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip
                              id="tooltip-view"
                              style={{ fontSize: "12px", padding: "2px" }}
                            >
                              Take Action
                            </Tooltip>
                          }
                        >
                          <i class="fa-solid fa-ellipsis-vertical"/>
                        </OverlayTrigger>
                      </button>
                   
                  </div>
                ) : record.task_type === "ATTENDANCE" ? (
                  <div
                    className="d-flex gap-2 mt-2"
                    style={{
                      cursor:
                        record.updated_status === "pending"
                          ? "pointer"
                          : "not-allowed",
                    }}
                  >
                    
                      <button
                        disabled={
                          record.updated_status === "pending" ? false : true
                        }
                        className="list-group-item list-group-item-action"
                        
                        onClick={(e) => {
                          e.preventDefault();
                          onRowClick(record);
                        }}
                      >
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip
                              id="tooltip-view"
                              style={{ fontSize: "12px", padding: "2px" }}
                            >
                              Take Action
                            </Tooltip>
                          }
                        >
                          <i class="fa-solid fa-ellipsis-vertical"/>
                        </OverlayTrigger>
                      </button>
                    
                  </div>
                ) : record.task_type === "Absentee" ? (
                  <div
                    className="d-flex gap-2 mt-2"
                    style={{
                      cursor:
                        record.updated_status === "PENDING"
                          ? "pointer"
                          : "not-allowed",
                    }}
                  >
                    
                      <button
                        disabled={
                          record.updated_status === "PENDING" ? false : true
                        }
                        className="list-group-item list-group-item-action"
                        
                        onClick={(e) => {
                          e.preventDefault();
                          onRowClick(record);
                        }}
                      >
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip
                              id="tooltip-view"
                              style={{ fontSize: "12px", padding: "2px" }}
                            >
                              Take Action
                            </Tooltip>
                          }
                        >
                          <i class="fa-solid fa-ellipsis-vertical"/>
                        </OverlayTrigger>
                      </button>
                    
                  </div>
                )  : record.task_type === "WORK_FROM_HOME" ? (
                  <div
                    className="d-flex gap-2 mt-2"
                    style={{
                      cursor:
                        record.wfh_approved_status == 1 ?  "not-allowed" : "pointer" 
                    }}
                  > 
                   
                      <button
                        disabled={record.wfh_approved_status == 1 ? true : false}
                        className="list-group-item list-group-item-action"
                      
                        onClick={(e) => {
                          e.preventDefault();
                          onWfhRowClicked(record);
                        }}
                      >
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip
                              id="tooltip-view"
                              style={{ fontSize: "12px", padding: "2px" }}
                            >
                              Take Action
                            </Tooltip>
                          }
                        >  
                       <i class="fa-solid fa-ellipsis-vertical"/>
                        </OverlayTrigger>
                      </button>
                    
                  </div>
                )  :  (
                  <></>
                )}
              </div>
            ),
          },
        ]
      : []),
  ];

  const smallScreencolumns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <span
          className="table-avatar"
          style={{ cursor: "pointer" }}
          onClick={() => onRowClick(record)}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (text, record) => (
        <span
          className="table-avatar"
          style={{ cursor: "pointer" }}
          onClick={() => onRowClick(record)}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text, record) => (
        <span
          onClick={() => onRowClick(record)}
          style={{
            color:
              record.updated_status === 1 ||
              record.updated_status === "pending" ||
              record.updated_status === "PENDING"
                ? "rgb(255 223 0)"
                : record.updated_status === 2 ||
                  record.updated_status === "approved" ||
                  record.updated_status === "APPROVED"
                ? "green"
                : "red",
            cursor: "pointer",
          }}
        >
          {record.updated_status === 1 ||
          record.updated_status == "pending" ||
          record.updated_status === "PENDING"
            ? "Pending"
            : record.updated_status === 2 ||
              record.updated_status == "approved" ||
              record.updated_status === "APPROVED"
            ? "Approved"
            : "Rejected"}
        </span>
      ),
      sorter: (a, b) => {
        const aNormalized = normalizeStatus(a.updated_status);
        const bNormalized = normalizeStatus(b.updated_status);

        const aValue =
          aNormalized && normalizedStatusOrder[aNormalized]
            ? normalizedStatusOrder[aNormalized]
            : Number.MAX_SAFE_INTEGER;
        const bValue =
          bNormalized && normalizedStatusOrder[bNormalized]
            ? normalizedStatusOrder[bNormalized]
            : Number.MAX_SAFE_INTEGER;

        return aValue - bValue;
      },
      sortDirections: ["ascend", "descend"],
    },
  ];

  const inDetailcolumns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <span className="table-avatar" onClick={() => onRowClick(record)}>
          {text}
        </span>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (text, record) => (
        <span className="table-avatar" onClick={() => onRowClick(record)}>
          {text}
        </span>
      ),
    },
    {
      title: "Applied on",
      dataIndex: "appliedOn",
    },
    {
      title: "Applied for",
      dataIndex: "appliedfor",
    },
    {
      title: "Punch In",
      dataIndex: "punchIn",
    },
    {
      title: "Punch Out",
      dataIndex: "punchOut",
    },
    {
      title: "Total Hours",
      dataIndex: "totalHours",
    },
    {
      title: "Leave days",
      dataIndex: "leave_days",
    },
    {
      title: "Leave apply period",
      dataIndex: "leave_apply_period",
    },
    {
      title: "Reason",
      dataIndex: "reason",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text, record) => (
        <span
          onClick={() => onRowClick(record)}
          style={{
            color:
              record.updated_status === 1 ||
              record.updated_status === "pending" ||
              record.updated_status === "PENDING"
                ? "rgb(255 223 0)"
                : record.updated_status === 2 ||
                  record.updated_status === "approved" ||
                  record.updated_status === "APPROVED"
                ? "green"
                : "red",
          }}
        >
          {record.updated_status === 1 ||
          record.updated_status == "pending" ||
          record.updated_status === "PENDING"
            ? "Pending"
            : record.updated_status === 2 ||
              record.updated_status == "approved" ||
              record.updated_status === "APPROVED"
            ? "Approved"
            : "Rejected"}
        </span>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Message",
      dataIndex: "message",
    },
    {
      title: "Remark",
      dataIndex: "remark",
      showInTable: false,
    },
    ...(loginEmployeeId === employee_id
      ? [
          {
            title: "Rejection Reason",
            dataIndex: "rejection_reason_input",
            render: (text, record) =>
              record?.rejection_reason || record?.approver_action_taken == 1 ? (
                record.rejection_reason
              ) : (
                <>
                  <textarea
                    className="form-control"
                    placeholder="Enter rejection reason"
                    value={rejectionReason}
                    onChange={(e) => {
                      setRejectionReason(e.target.value);
                      setRejectionReasonError((prev) => ({
                        ...prev,
                        [record.key]: "",
                      }));
                    }}
                  />
                  {rejectionReasonError[record.key] && (
                    <span className="text-danger">
                      * {rejectionReasonError[record.key]}
                    </span>
                  )}
                </>
              ),
          },
        ]
      : []),
    ...(loginEmployeeId === employee_id
      ? [
          {
            title: "Action",
            render: (text, record) => (
              <div className="action-menu">
                {record.task_type === "REIMBURSEMENT" ? (
                  <div
                    className="d-flex gap-2 mt-2"
                    style={{
                      cursor:
                        record.updated_status === 1 ? "pointer" : "not-allowed",
                    }}
                  >
                    {actionStatus.map((action, index) => (
                      <button
                        type="button"
                        disabled={record.updated_status === 1 ? false : true}
                        className={`btn btn-outline-${
                          record.updated_status != 1
                            ? "text-muted"
                            : action.label == "Approve"
                            ? "success"
                            : "danger"
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          setIsModalOpen(true);
                          setCurrentStatus(record?.updated_status);
                          setReimbursementId(record?.task_id);
                          setAcknowledgeAttachment(record?.attachment);
                        }}
                      >
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip
                              id="tooltip-view"
                              style={{ fontSize: "12px", padding: "2px" }}
                            >
                              View attachment
                            </Tooltip>
                          }
                        >
                          <>
                            {" "}
                            {action.label == "Approve" ? "Approve" : "Reject"}
                          </>
                        </OverlayTrigger>
                      </button>
                    ))}
                  </div>
                ) : record.task_type === "LEAVE" ? (
                  <div
                    className="d-flex gap-2 mt-2"
                    style={{
                      cursor:
                        record.updated_status === 1 ? "pointer" : "not-allowed",
                    }}
                  >
                    {actionStatus.map((action, index) => (
                      <button
                        disabled={record.updated_status === 1 ? false : true}
                        type="button"
                        className={`btn btn-outline-${
                          record.updated_status != 1
                            ? "text-muted"
                            : action.label == "Approve"
                            ? "success"
                            : "danger"
                        }`}
                        key={index}
                        onClick={(e) => {
                          e.preventDefault();
                          actionStatusHandler(
                            action.value,
                            record.task_id,
                            record.task_type
                          );
                          setUpdatedRemainingDays({
                            leave_employee_id: record?.employee_id,
                            no_of_days: record?.leave_days,
                            leave_type_id: record?.leave_type_id,
                          });
                        }}
                      >
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip
                              id="tooltip-view"
                              style={{ fontSize: "12px", padding: "2px" }}
                            >
                              {action.label == "Approve"
                                ? action.label
                                : action.label}
                            </Tooltip>
                          }
                        >
                          <>
                            {" "}
                            {action.label == "Approve" ? "Approve" : "Reject"}
                          </>
                        </OverlayTrigger>
                      </button>
                    ))}
                  </div>
                ) : record.task_type === "ATTENDANCE" ? (
                  <div
                    className="d-flex gap-2 mt-2"
                    style={{
                      cursor:
                        record.updated_status === "pending"
                          ? "pointer"
                          : "not-allowed",
                    }}
                  >
                    {actionStatus.map((action, index) => (
                      <button
                        disabled={
                          record.updated_status === "pending" ? false : true
                        }
                        className={`btn btn-outline-${
                          record.updated_status != "pending"
                            ? "text-muted"
                            : action.label == "Approve"
                            ? "success"
                            : "danger"
                        }`}
                        key={index}
                        onClick={(e) => {
                          e.preventDefault();
                          attendaceApproval(
                            record.applicant_id,
                            record.appliedfor,
                            record.approval_id,
                            action.label,
                            record.task_id,
                            record.remark
                          );
                        }}
                      >
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip
                              id="tooltip-view"
                              style={{ fontSize: "12px", padding: "2px" }}
                            >
                              {action.label == "Approve"
                                ? action.label
                                : action.label}
                            </Tooltip>
                          }
                        >
                          <>
                            {" "}
                            {action.label == "Approve" ? "Approve" : "Reject"}
                          </>
                        </OverlayTrigger>
                      </button>
                    ))}
                  </div>
                ) : record.task_type === "Absentee" ? (
                  <div
                    className="d-flex gap-2 mt-2"
                    style={{
                      cursor:
                        record.updated_status === "PENDING"
                          ? "pointer"
                          : "not-allowed",
                    }}
                  >
                    {absenceActionStatus.map((action, index) => (
                      <button
                        disabled={
                          record.updated_status === "PENDING" ? false : true
                        }
                        className={`btn btn-outline-${
                          record.updated_status != "PENDING"
                            ? "text-muted"
                            : action.label == "Allow Leave" ||
                              action.label == "Allow Attendance"
                            ? "success"
                            : "danger"
                        }`}
                        key={index}
                        onClick={(e) => {
                          e.preventDefault();
                          handleAbsenteeAction(record, action);
                        }}
                      >
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip
                              id="tooltip-view"
                              style={{ fontSize: "12px", padding: "2px" }}
                            >
                              {action.label}
                            </Tooltip>
                          }
                        >
                          <>
                            {action.label == "Allow Leave"
                              ? "Allow Leave"
                              : action.label == "Allow Attendance"
                              ? "Allow Attendance"
                              : "Reject"}
                          </>
                        </OverlayTrigger>
                      </button>
                    ))}
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ),
          },
        ]
      : []),
  ];

  const onRowClick = (record) => {
    
    setSelectedRow(record);
    setIsModalVisible(true);
  };

 const onWfhRowClicked = async (record) => {
  console.log("record", record);

  const result = await Swal.fire({
    title: "Do you want to Approve the Action?",
    showDenyButton: true,
    showCancelButton: true,
    confirmButtonText: "Approve",
    denyButtonText: `Reject`,
    didOpen: () => {
      const swalContainer = Swal.getPopup();
      const approveBtn = swalContainer.querySelector('.swal2-confirm');
      const rejectBtn = swalContainer.querySelector('.swal2-deny');

      if (record?.wfh_status === 'approved') {
        approveBtn.disabled = true;
      }
      if (record?.wfh_status === 'rejected') {
        rejectBtn.disabled = true;
      }
    }
  });

  const assigned_id = localStorage.getItem('employeeID');

  try {
    if (result.isConfirmed) {
      const status = 'approved';
      await api.put(
        `company/update_wfh_dates?assigned_id=${assigned_id}&status=${status}&wfh_status=1&wfh_id=${record?.wfh_id}`
      );
      fetchLeaves();
      Swal.fire("Saved!", "", "success");
    } else if (result.isDenied) {
      const status = 'rejected';
      await api.put(
        `company/update_wfh_dates?assigned_id=${assigned_id}&status=${status}&wfh_status=0&wfh_id=${record?.wfh_id}`
      );
      fetchLeaves();
      Swal.fire("Changes are not saved", "", "info");
    }
  } catch (error) {
    console.error("Error updating WFH status:", error);
    Swal.fire("Error!", "Something went wrong. Please try again.", "error");
  }
  
};



  const handleRemarkChange = (key, newRemark) => {
    console.log("newRemark" , newRemark , key);
    setLeaveElements((prevData) =>
      prevData.map((item) =>
        item.key === key ? { ...item, remark: newRemark } : item
      )
    );
    // Also update selectedRow if it's the same key
    setSelectedRow((prev) =>
      prev && prev.key === key ? { ...prev, remark: newRemark } : prev
    );
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setSelectedRow(null);
    setRejectionReasonError({});
    setRejectionReason("");
  };

  return (
    <div className={`page-wrapper ${loading ? "position-relative" : ""}`}>
      <div className="content container-fluid position-relative">
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center h-100 w-100 position-absolute"
            style={{ zIndex: 9999 }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <>
            <Breadcrumbs
              maintitle={`${employeeName} Task Box`}
              title="Dashboard"
              subtitle="Task Box"
              name={t("Create Daily task")}
              openModal={() =>
                navigate("../create-task", {
                  state: { createTask: true },
                })
              }
              page="create-task"
              action="create"
            />
            <AttachmentModal
              show={isModalOpen}
              onHide={() => {
                setAcknowledge(false);
                setIsModalOpen(false);
              }}
              attachmentUrl={acknowledgeAttachment}
              acknowledge={acknowledge}
              setAcknowledge={setAcknowledge}
              currentStatus={currentStatus}
              reimbursementId={reimbursementId}
              reimbursementStatusIdHandler={actionStatusHandler}
              config={{ IMAGE_URL: config.IMAGE_URL }}
            />
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex gap-2 justify-content-end align-items-center mb-2">
                  <button
                    className={`${
                      taskType === "workplace"
                        ? "btn btn-primary"
                        : "btn btn-outline-primary"
                    }`}
                    onClick={() => {
                      setTaskType("workplace");
                      setSelectedFilter(null);
                    }}
                  >
                    Workplace Task
                  </button>
                  <button
                    className={`${
                      taskType === "daily_task"
                        ? "btn btn-primary"
                        : "btn btn-outline-primary"
                    }`}
                    onClick={() => {
                      setTaskType("daily_task");
                      setSelectedFilter(null);
                    }}
                  >
                    Daily Task
                  </button>
                  <FilterComponent
                    filterOptions={filterOptions}
                    onApplyFilter={
                      taskType === "workplace"
                        ? (filter) => setSelectedFilter(filter)
                        : (filter) => {
                            const queryParams = Object.entries(filter)?.length
                              ? filter
                              : null;
                            setAssignmentTaskFilter(queryParams);
                          }
                    }
                    filterLabel="Filter Tasks"
                    resetLabel="Reset Filter"
                    applyLabel="Apply"
                  />
                </div>
                {taskType === "workplace" ? (
                  <div className="table-responsive">
                    <Table
                      className="table-striped"
                      columns={isMobile ? smallScreencolumns : columns}
                      dataSource={filteredLeaveElements}
                      rowKey={(record) => record.key}
                      pagination={{ pageSize: paginationValue }}
                      scroll={{ x: true }}
                      tableLayout="auto"
                    />
                  </div>
                ) : (
                  <CreateTask
                    showAssignments={taskType === "daily_task" ? true : false}
                    filter={assignmentTaskFilter}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </div>
      <DeleteModal Name="Delete Overtime" />
      <Loader show={spinner.show} loadingMessage={spinner.message} />
      {selectedRow && (
        <RowDetailModal
          visible={isModalVisible}
          onClose={closeModal}
          record={selectedRow}
          columns={inDetailcolumns}
          title={capitalizeFirstLetter(selectedRow?.task_type)}
          onRemarkChange={handleRemarkChange}
        />
      )}
      {isModalOpen && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};

export default Taskbox;